import { render } from "./MainContentArea.vue?vue&type=template&id=28673950"
import script from "./MainContentArea.vue?vue&type=script&lang=js"
export * from "./MainContentArea.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__